import * as React from 'react';
import { observer } from 'mobx-react';
import * as _ from 'lodash';
import { faCalendar, faDog, faGenderless, faHeart } from '@fortawesome/free-solid-svg-icons';
import { ProfileModel } from '../../../../core/models/ProfileModel';
import { useNavigate } from 'react-router-dom';
import { ResourcePageHeaderWidget } from '../../../../widgets/pages/ResourcePageHeaderWidget';
import { RelationshipStatus } from '@foxbun/lib-goferal-types';
import { Routing } from '../../../Routing';
import { ButtonWidget } from '../../../../widgets/controls/ButtonWidget';

export interface ProfileHeaderPageProps {
  user: ProfileModel;
}

export const ProfileHeaderPage: React.FC<ProfileHeaderPageProps> = observer((props) => {
  const { user } = props;
  const profile = user.data;
  const navigate = useNavigate();

  return (
    <ResourcePageHeaderWidget
      hero_image={user.headerImage}
      label={profile?.profile_name}
      primary_image={user.image}
      primaryAction={
        user.isMe ? (
          <ButtonWidget
            label="edit"
            action={() => {
              navigate(Routing.EDIT_PROFILE, { state: 'push' });
            }}
          />
        ) : null
      }
      meta={[
        profile.identity?.length > 0
          ? {
              key: 'primary',
              primary: true,
              icon: faDog,
              value: profile.identity?.map((i) => _.capitalize(i)).join(', ')
            }
          : null,
        {
          icon: faGenderless,
          value: profile.sexual_orientation,
          key: 'sexual_orientation'
        },
        {
          icon: faCalendar,
          value: `${profile.age} years old`,
          key: 'age'
        },
        user.data.relationship_status !== RelationshipStatus.BLANK
          ? {
              icon: faHeart,
              value: user.relationshipStatus,
              key: 'relationship'
            }
          : null
      ]}
    />
  );
});
